<template>
  <div class="ah-bar">
    <AhButton
      :id="id"
      class="ah-bar__button"
      @ah-button-clicked="handleClick"
    >
      <span :class="computedShowTitle ? 'sr-only' : ''">
        {{ backButtonLabel }}
      </span>
    </AhButton>
    <span
      v-if="computedShowTitle"
      class="ah-bar__title"
    >
      {{ panelTitle }}
    </span>
  </div>
</template>
<script>
  import AhButton from '../../atoms/AhButton/AhButton.vue';
  import { BACK_BUTTON_LABELS } from '../../../constants/wording.js';
  export default {
    name: 'AhBar',
    components: {
      AhButton
    },
    inject: {
      $lang: {
        default: () => function() { return 'en'; },
      }
    },
    props: {
      /**
       * @param {String} id             id of the button
      **/
      id: {
        type: String,
        required: true,
      },
      /**
       * @param {String} panelTitle     Title of panel opened
      **/
      panelTitle: {
        type: String,
        default: ''
      },
      /**
       * @param {Boolean} showTitle     Boolean that displays either Back or panel title
      **/
      showTitle: {
        type: Boolean,
        default: false
      }
    },
    computed: {
      backButtonLabel() {
        return BACK_BUTTON_LABELS[this.lang];
      },
      computedShowTitle() {
        return (this.showTitle && this.panelTitle != '');
      },
      lang() {
        return this.$lang();
      }
    },
    methods: {
      handleClick () {
        this.$emit('ah-bar-clicked');
      }
    }
  };
</script>
